export default __webpack_public_path__ + "static/media/iab-active-alert.f228970a.svg";